import React, { useState, useEffect } from 'react';
import { graphql, Link, navigate } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { GatsbyImage } from "gatsby-plugin-image";
import { Helmet } from 'react-helmet';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { Disclosure } from '@headlessui/react';
import { FunnelIcon, XMarkIcon, ChevronUpIcon } from '@heroicons/react/24/solid';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

  export default ({ data, location }) => {
    const urlParams = new URLSearchParams(location.search);
    const [selectedFilters, setSelectedFilters] = useState({
      cat: [],
      type: [],
      season: [],
      theme: [],
    });
  
    const [isFilterOpen, setIsFilterOpen] = useState(false); // State voor de slide-in filter
    
    useEffect(() => {
      if (isFilterOpen) {
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed"; // Zorgt ervoor dat de pagina niet verschuift
        document.body.style.width = "100%";
      } else {
        document.body.style.overflow = "auto";
        document.body.style.position = "static"; // Zet de pagina weer terug naar normaal
      }
    }, [isFilterOpen]);



    useEffect(() => {
      const params = new URLSearchParams(location.search);
      setSelectedFilters({
        cat: params.getAll('cat'),
        type: params.getAll('type'),
        season: params.getAll('season'),
        theme: params.getAll('theme'),
      });
    }, [location.search]);
  
    const handleFilterChange = (category, value) => {
      const params = new URLSearchParams(location.search);
      const values = params.getAll(category);
  
      if (values.includes(value)) {
        params.delete(category);
        values.filter(v => v !== value).forEach(v => params.append(category, v));
      } else {
        params.append(category, value);
      }
  
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };
  
    const filteredAndSortedNodes = data.allWpSurfvakantie.edges
      .filter(({ node }) => {
        return (
          (!selectedFilters.cat.length || selectedFilters.cat.some(d => node.surfvakantieNieuw.categories.includes(d))) &&
          (!selectedFilters.type.length || selectedFilters.type.some(t => node.surfvakantieNieuw.categories.includes(t))) &&
          (!selectedFilters.season.length || selectedFilters.season.some(s => node.surfvakantieNieuw.categories.includes(s))) &&
          (!selectedFilters.theme.length || selectedFilters.theme.some(th => node.surfvakantieNieuw.categories.includes(th)))
        );
      })
      .sort((a, b) => {
        const orderA = a.node.surfvakantieNieuw.customOrder || 0;
        const orderB = b.node.surfvakantieNieuw.customOrder || 0;
        return orderA - orderB;
      });
  
      const isEnglish = location.pathname.includes('/en/'); // ✅ Controleer de taal

  const filterGroups = [
    { 
      title: isEnglish ? "Target Audience" : "Doelgroep", 
      key: "cat", 
      options: [
        { value: "adults", label: isEnglish ? "Adults" : "Volwassenen" },
        { value: "family", label: isEnglish ? "Family" : "Gezinnen" },
        { value: "juniors", label: isEnglish ? "Juniors" : "Jongeren" }
      ]
    },
    { 
      title: isEnglish ? "Traveler Type" : "Type Reiziger", 
      key: "type", 
      options: [
        { value: "solo", label: isEnglish ? "Solo" : "Alleenreizend" },
        { value: "friends", label: isEnglish ? "Friends" : "Vrienden" },
        { value: "couple", label: isEnglish ? "Couple" : "Stel" }
      ]
    },
    { 
      title: isEnglish ? "Season" : "Seizoen", 
      key: "season", 
      options: [
        { value: "spring", label: isEnglish ? "Spring" : "Lente" },
        { value: "summer", label: isEnglish ? "Summer" : "Zomer" },
        { value: "autumn", label: isEnglish ? "Autumn" : "Herfst" }
      ]
    },
    { 
      title: isEnglish ? "Theme" : "Thema", 
      key: "theme", 
      options: [
        { value: "yoga", label: "Yoga" },
        { value: "language", label: isEnglish ? "Language" : "Taalcursus" },
        { value: "bus", label: isEnglish ? "Bus trip" : "Busreis" },
        { value: "kite", label: isEnglish ? "Kitesurfing" : "Kitesurfen" },
        { value: "coworking", label: isEnglish ? "Coworking" : "Samenwerken" },
        { value: "glamping", label: "Glamping" },
        { value: "surfcamp", label: isEnglish ? "Surf Camp" : "Surfcamp" },
        { value: "surflodge", label: isEnglish ? "Surf Lodge" : "Surflodge" }
      ]
    }
  ];
  
  const currentCategory = data.wpSurfvakantie.title;

  const [isVisible, setIsVisible] = useState(false);

  // Functie om de state te toggelen
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const countByCategory = (categoryKey, option) => {
    return data.allWpSurfvakantie.edges.filter(({ node }) =>
      node.surfvakantieNieuw.categories.includes(option)
    ).length;
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": isEnglish ? "Home" : "Home",
        "item": `https://surfawhile.com${isEnglish ? "/en" : "/"}`
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": isEnglish ? "Surf Camps" : "Surfvakanties",
        "item": `https://surfawhile.com${isEnglish ? "/en/surf-camps" : "/surfvakanties"}`
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": currentCategory,
        "item": `https://surfawhile.com${location.pathname}`
      }
    ]
  };

const faqData = data.wpSurfvakantie.listPagesSurfvakanties.veelgesteldeVragen || [];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqData.map(faq => ({
    "@type": "Question",
    "name": faq.vraag, // ✅ Gebruik het correcte veld
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.antwoord // ✅ Gebruik het correcte veld
    }
  }))
};

  return (

<Layout>

<Helmet>
  <link rel="canonical" href={`https://www.surfawhile.com/surfvakanties/${location.pathname}`} />
  
  {breadcrumbSchema && (
    <script type="application/ld+json">
      {JSON.stringify(breadcrumbSchema)}
    </script>
  )}

  {faqSchema?.mainEntity?.length > 0 && (
    <script type="application/ld+json">
      {JSON.stringify(faqSchema)}
    </script>
  )}
</Helmet>

      <SEO title={data.wpSurfvakantie.seo.title} description={data.wpSurfvakantie.seo.metaDesc} />

      <div className="bg-stone-100 w-full">
    <div className="container mx-auto px-4 py-5">

  


      <div className="flex flex-col lg:flex-row">
       {/* 🔹 Slide-in Filter Button (Mobile) */}



{/* 🔹 Sidebar (Slide-in op mobiel) */}
<aside className={`z-50 fixed lg:relative top-0 left-0 w-full lg:w-1/4 h-full bg-white rounded-lg p-4 transition-transform duration-300 ease-in-out
  ${isFilterOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0 z-20 flex flex-col`}
  style={{ maxHeight: "100vh" }}
>
  {/* 🔹 Wrapper om scroll mogelijk te maken */}
  <div className="flex-1 overflow-y-auto p-2" style={{ WebkitOverflowScrolling: "touch", maxHeight: "calc(100vh - 60px)" }}>
    <p className="my-2">
      <Link className="font-inter font-semibold text-sm hover:underline text-black" to={location.pathname}>x Reset alle filters</Link>
    </p>

    {/* 🔹 Close Button (Mobile) */}
    <button className="lg:hidden absolute top-1 right-3 p-2" onClick={() => setIsFilterOpen(false)}>
      <XMarkIcon className="w-6 h-6 text-gray-600" />
    </button>

    {filterGroups.map(group => (
      <Disclosure as="div" className="mt-5" defaultOpen key={group.key}>
        {({ open }) => (
          <>
            <Disclosure.Button className="flex w-full justify-between rounded-lg bg-stone-100 px-4 py-2 text-left text-sm font-medium text-slate-900 hover:bg-stone-200">
              <h4 className="font-oswald uppercase font-bold mt-2">{group.title}</h4>
              <ChevronUpIcon className={`${open ? 'rotate-180 transform' : ''} h-7 w-7 mt-1 text-black font-bold`} />
            </Disclosure.Button>
            <Disclosure.Panel className="px-4 pb-2 pt-4 text-md text-gray-500">
              <ul className="font-inter list-none">
                {group.options.map(option => (
                  <li key={option.value}>
                    <label className="flex items-center -ml-4">
                      <input
                        type="checkbox"
                        checked={selectedFilters[group.key].includes(option.value)}
                        onChange={() => handleFilterChange(group.key, option.value)}
                      />
                      <span className="ml-2 font-semibold capitalize">{option.label}</span>
                    </label>
                  </li>
                ))}
              </ul>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    ))}
  </div>

{/* 🔹 Filter Toevoegen Knop (blijft onderaan zichtbaar) */}
{isFilterOpen && (
    <div className="lg:hidden fixed bottom-0 right-0 w-1/2 bg-white p-4 pointer">
      <button 
        className="w-full bg-black text-white py-3 text-lg font-semibold rounded-xl font-inter"
        onClick={() => setIsFilterOpen(false)}
      >
        Naar {filteredAndSortedNodes.length} surfvakanties
      </button>
    </div>
  )}
  
</aside>


        <div className="w-full lg:w-3/4 p-4 bg-stone-100">

        <div className="breadcrumbs font-inter text-sm py-2 text-slate-400 font-semibold">
          <Link className="text-slate-400" to={isEnglish ? "/en" : "/"}> {isEnglish ? "Home " : "Home "} </Link> &gt; 
          <Link className="text-slate-400" to={isEnglish ? "/en/surf-camps" : "/surfvakanties"}>
            {isEnglish ? " Surf Camps" : " Surfvakanties"}
          </Link> &gt;
          <span className="text-slate-800"> {currentCategory}</span>
        </div>

                        
          <h1 className="text-4xl mb-4">Surfvakanties {data.wpSurfvakantie.title} </h1>
          <p className="font-inter mb-5">
            {data.wpSurfvakantie.listPagesSurfvakanties.introText[0].introTextOne}</p>

            {isVisible && (

            <p className="font-inter mt-3 mb-5">
              {data.wpSurfvakantie.listPagesSurfvakanties.introText[0].introTextTwo}
            </p>
           )}

          <button onClick={() => setIsVisible(!isVisible)} className="font-inter font-semibold hover:underline">
            {isEnglish ? (isVisible ? 'Read less -' : 'Read more +') : (isVisible ? 'Minder lezen -' : 'Lees meer +')}
          </button>

          {/* 🔹 Filter Button (Mobile) */}
          <button 
  className="lg:hidden flex items-center justify-center bg-black text-white py-2 rounded-lg mb-4 mt-2 font-inter font-semibold w-48 text-center"
  onClick={() => setIsFilterOpen(true)}
>
  <FunnelIcon className="w-5 h-5 mr-2" /> Filters
</button>

          <span className="font-inter font-semibold block">
            {filteredAndSortedNodes.length} {isEnglish ? "surf camps found." : "surfvakanties gevonden."}
          </span>

          <div className="grid gap-4 md:grid-cols-2 grid-cols-1 grid-rows-">
        {filteredAndSortedNodes.map(({ node }) => (
          <div
            key={node.uri}
            className={`card grid-item font-inter bg-white rounded-xl m-2 pb-2 relative hover:shadow-md transition duration-300 ${node.surfvakantieNieuw.typeAccommodatie} ${node.surfvakantieNieuw.land} ${node.surfvakantieNieuw.categories.join(' ')} show-grid-item`}
          >
            <Link to={node.uri}>
            
            <Swiper
                        spaceBetween={50}
                        slidesPerView={1}
                        pagination={{ dynamicBullets: true }}
                        navigation={{ clickable: true }} 
                        modules={[Pagination, Navigation]}
                      >
                        {/* Voeg de featured image toe als eerste afbeelding */}
                        {node.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData && (
                          <SwiperSlide key="featured-image" onClick={(e) => {
                            e.stopPropagation();
                            navigate(node.uri);
                          }}>

                            <img
                            src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(node.featuredImage.node)}&format=webp&w=600&h=400&fit=crop&q=50`}
                              // src={node.featuredImage.node.localFile.childImageSharp.gatsbyImageData}
                              alt={node.featuredImage.node.altText || `Gallery Image of ${node.title}`}
                              width={300}
                              height={200}
                              loading="lazy"
                            />
                          </SwiperSlide>
                        )}

                        {/* Voeg de afbeeldingen uit de gallery toe */}
                        {node.surfvakantieNieuw.gallery.slice(0, 4).map((image, index) => (
                          <SwiperSlide key={`gallery-image-${index}`} onClick={(e) => {
                            e.stopPropagation();
                            navigate(node.uri);
                          }}>
                            <img
                              src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(image.publicUrl)}&format=webp&w=600&h=400&fit=crop&q=50`}
                              alt={image.altText || `Gallery Image ${index + 1} of ${node.title}`}
                              width={300} // Specificeer de gewenste breedte
                              height={200} // Specificeer de gewenste hoogte
                            />
                          </SwiperSlide>
                        ))}
                    </Swiper>

        <div className="flex justify-between absolute top-0 w-full">

        {/* {node.surfvakantieNieuw.hurryShout} */}
        {node.surfvakantieNieuw.hurryShout && (
            <div className="bg-sky-50 font-inter px-2 py-1 m-1 rounded-lg z-10 inline text-sm">
              <p className="font-inter font-semibold inline">{node.surfvakantieNieuw.hurryShout}</p>
            </div>
          )}

          {/* Conditional rendering of the "Kortingsactie" div */}
          {node.surfvakantieNieuw.discount && (
            <div className="bg-orange-500 font-inter px-2 py-1 text-white m-1 rounded-lg z-10 text-sm">
              <p className="font-inter font-semibold inline">Kortingsactie</p>
            </div>
          )}  

          </div>
          
          <div className="m-4">
          <div className="mt-2 -mb-2 text-xs font-inter text-slate-500 uppercase font-semibold flex justify-between">
              <div>{node.surfvakantieNieuw.typeAccommodatie} {node.surfvakantieNieuw.land}</div>
            
              {node.surfvakantieNieuw.rating !== null && !isNaN(node.surfvakantieNieuw.rating) && (
                  <div>
                <p className="ml-4 text-sm font-semibold text-slate-500">
                  <svg aria-hidden="true" className="w-5 h-5 text-yellow-400 inline -mt-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <title>Rating star</title>
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    ></path>
                  </svg>
                  {node.surfvakantieNieuw.rating} / 5
                </p>
              </div>
              )}
            </div>

                <h3 className="text-lg font-bold mt-1">{node.title}</h3>

                <ul className="list-none font-inter text-xs md:text-sm">
              <li className="flex items-center my-1">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-5 h-5 -ml-6 inline text-slate-500">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>

                <p className="ml-4 text-slate-500 text-xs md:text-sm">
                  {node.surfvakantieNieuw.inleidingLocatie}, {node.surfvakantieNieuw.inleidingRegio}
                </p>
              </li>


              <li className="flex items-center justify-between my-1 w-full">
                <div className="text-slate-500 text-xs md:text-sm">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 -ml-6 align-top inline">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
              </svg>

                  <p className="ml-4 inline">{node.surfvakantieNieuw.inleidingMinimumleeftijd}</p>
                </div>
              </li>

              <li className="flex items-center justify-between my-1 w-full">
                <div className="text-slate-500 text-xs md:text-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 -ml-6 align-top inline">
                    <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" />
                  </svg>

                  <p className="ml-4 inline">{node.surfvakantieNieuw.populair}</p>
                </div>
              </li>


              <li className="flex items-center justify-between my-1 w-full">
                <div className="text-slate-500 text-xs md:text-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 -ml-6 -mt- inline">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
                  </svg>

                  <p className="ml-4 inline">{node.surfvakantieNieuw.inleidingOpen}</p>
                </div>
              </li>

              <li className="flex items-center justify-between my-1 w-full">
                <div className="text-slate-500 text-xs md:text-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 -ml-6 -mt- inline">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>

                  <p className="ml-4 inline">{node.surfvakantieNieuw.extra}</p>
                </div>
              </li>


              <li className="flex items-center justify-between my-1 w-full">
                <div className="text-slate-500 text-xs md:text-sm">
                <svg data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="w-5 h-5 -ml-6 -mt- inline">
  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"></path>
</svg>
                  <p className="ml-4 inline">{node.surfvakantieNieuw.inleidingVervoer}</p>
                </div>
              </li>

              <li className="flex items-center flex justify-end">
                <button className="bg-black text-white font-semibold py-2 px-4 rounded-lg float-right mt-3">Ontdek v.a. € {node.surfvakantieNieuw.inleidingPrijs},-</button>
              </li>
            </ul>

            </div>

            </Link>
          </div>
        ))}
      </div>

        </div>
      </div>

      <div className="flex flex-col lg:flex-row my-3">
  
  <div className="my-10 lg:w-2/3 w-full mx-auto surfvakantieBody">

  {data.wpSurfvakantie.listPagesSurfvakanties.overSurfenInBestemming ? (
    <div
      className="font-inter"
      dangerouslySetInnerHTML={{
        __html: data.wpSurfvakantie.listPagesSurfvakanties.overSurfenInBestemming,
      }}
    />
  ) : (
    <p className="text-gray-500">Geen aanvullende informatie beschikbaar.</p>
  )}


<div className="faq-section bg-stone-100 rounded-lg mt-8">
  <h2 className="text-2xl font-bold mb-4">Veelgestelde vragen over Surfvakanties in {data.wpSurfvakantie.title}</h2>
  {faqData.map((faq, index) => (
    <Disclosure as="div" className="mt-5" key={index} defaultOpen>
      {({ open }) => (
        <>
          <Disclosure.Button className="flex w-full justify-between rounded-lg bg-stone-200 px-4 py-2 text-left text-sm font-medium text-slate-900 hover:bg-stone-200">
            <h4 className="font-oswald uppercase font-bold mt-2">{faq.vraag}</h4>
            <ChevronUpIcon className={`${open ? 'rotate-180 transform' : ''} h-7 w-7 mt-1 text-black font-bold`} />
          </Disclosure.Button>
          <Disclosure.Panel className="px-4 pb-2 pt-4 text-md text-gray-500">
            <div className="font-inter text-sm leading-relaxed"
              dangerouslySetInnerHTML={{ __html: faq.antwoord }} 
            />
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  ))}
</div>
</div>
</div>
      </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
query ($id: Int!) { # ✅ Gebruik Int! Geen String meer
  allWpSurfvakantie(
    filter: {
      parentDatabaseId: { eq: $id } # ✅ Gebruik hier ook $id als Int
      surfvakantieNieuw: { categories: { nin: ["group"] } }
      language: { code: { eq: NL } }
    }
  ) {
      edges {
        node {
          uri
          title
          surfvakantieNieuw {
            land
            inleidingLocatie
            inleidingRegio
            inleidingOpen
            inleidingVervoer
            rating
            categories
            typeAccommodatie
            customOrder
            discount
            hurryShout
            populair
            extra
            inleidingMinimumleeftijd
            inleidingPrijs
            gallery {
              id
              sourceUrl
              publicUrl
              localFile {
                id
                childImageSharp {
                  gatsbyImageData(
                    width: 900
                    height: 600
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                    layout: CONSTRAINED
                  )
                }
              }
            }
          }
          featuredImage {
            node {
              uri
               sourceUrl
              publicUrl
              localFile {
                id
                childImageSharp {
                  gatsbyImageData(
                    height: 400
                    width: 600
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
        }
      }
    }
      wpSurfvakantie(databaseId: { eq: $id }) {
      title
      databaseId
      seo {
        title
        metaDesc
      }
      listPagesSurfvakanties {
        introText {
          introTextOne
          introTextTwo
        }
        overSurfenInBestemming
        praktischeInformatie
        surfseizoenen
        besteSurfspots
        transport
        veelgesteldeVragen{
          vraag
          antwoord
        }
      }
    }
  }
`;